import type { ParameterBindingKind } from '../../revit/projectParameterMutationPlan';

export interface ParameterBindingGroup {
  parameterNames: string[];
  bindingKind: ParameterBindingKind;
}

export interface ParameterBindingEntry {
  parameterName: string;
  bindingKind: ParameterBindingKind;
}

export function groupParameterEntriesByBindingKind(
  entries: ParameterBindingEntry[]
): ParameterBindingGroup[] {
  const groupedNames = new Map<ParameterBindingKind, string[]>();

  entries.forEach((entry) => {
    const parameterNames = groupedNames.get(entry.bindingKind) ?? [];
    parameterNames.push(entry.parameterName);
    groupedNames.set(entry.bindingKind, parameterNames);
  });

  return Array.from(groupedNames, ([bindingKind, parameterNames]) => ({
    parameterNames,
    bindingKind,
  }));
}
